import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    clear: 'Clear',
    filters: 'Advanced filters',
    placeholder: {
      long: 'Search for a transaction',
      short: 'Search',
    },
  },
  fr: {
    clear: 'Effacer',
    filters: 'Filtres avancés',
    placeholder: {
      long: 'Rechercher une transaction',
      short: 'Rechercher',
    },
  },
} as const);

export default locales;
